export default __webpack_public_path__ + "static/media/waveC.2b91b2d8.svg";